import React from "react";
import heroimg from "./../../static/img/skillset.png";
import * as Scroll from 'react-scroll';

const Hero = class extends React.Component {
  render() {
    let ScrollLink       = Scroll.Link;
    return (
    
        <section class="hero  is-bold " style={{padding:70,justifyContent:'center',background: "linear-gradient(to bottom right,#80159F, #8061FF)"}}>
 
            <div class="columns is-vcentered .is-centered"  style={{alignSelf:'center'}}>
              <div class="column" style={{color:'#ffffff'}}>
                <div >
                  <h1 class="title" style={{color:'#ffffff'}}>Mobile & Web </h1>
                  <h2 class="subtitle" style={{color:'#ffffff'}}>App Development</h2>
                  <p> Providing development services for a broad variety of industries. Get in touch with me and let's discuss how to make a difference in your niche.</p>
                  
                  <a
                  href="https://drive.google.com/file/d/1AdUauAwdqZnImTRkysulTgsU_Css4FXn/view?usp=sharing"
                  target="_blank"
                ><button class="btn">  Download  </button></a> 
                 <ScrollLink
               to="about"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
               >
                <button class="btn" style={{backgroundColor:'#333',color:'#CCCCCC'}}>   More.... </button>
                </ScrollLink>
                </div>
              </div>
              <div class="column"> <img src={heroimg} alt="heroimg" /></div>
            </div>
       
        </section>
     
    );
  }
};

export default Hero;
